import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { startLoadingTransacciones } from '../../../actions/transacciones';

const HistorialTransacciones = ({ suscripcionId }) => {
  const dispatch = useDispatch();
  const { colores } = useSelector(state => state.ui);
  const { transacciones } = useSelector(state => state.transacciones);

  useEffect(() => {
    if (suscripcionId) {
      dispatch(startLoadingTransacciones(suscripcionId));
    }
  }, [suscripcionId, dispatch]);

  return (
    <section className="section datos">
      <h3 style={{ color: colores.colorPrincipal }}>Historial de pagos</h3>
      <div className="section pagos">
        <div className="pagos-table">
          <div className="pagos-row headers">
            <div className="plan">Fecha</div>
            <div className="facturado">Estado</div>
            <div className="cuota">Importe</div>
            <div className="pago">Código</div>
            <div className="factura">Observaciones</div>
          </div>
          {!transacciones ? (
            <p style={{ padding: '1rem' }}>Cargando...</p>
          ) : transacciones.length === 0 ? (
            <p style={{ padding: '1rem' }}>No hay transacciones registradas</p>
          ) : (
            transacciones.map((tx) => (
              <div className="pagos-row" key={tx._id}>
                <div className="plan">
                  {new Date(tx.fechaMovimiento).toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  })}
                </div>
                <div className="facturado">{tx.estadoTransaccion}</div>
                <div className="cuota">{tx.total.toFixed(2)}€</div>
                <div className={`pago ${tx.estadoTransaccion === 'pendiente' ? 'pendiente' : ''}`}>
                  {tx.codigoResultado}
                </div>
                <div className="factura">{tx.observaciones}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default HistorialTransacciones;
